import React from 'react';
import {NavLink} from "react-router-dom";

const styles = {
  header: {
    padding: '20px',
    textAlign: 'left',
    fontSize: '20px',
    fontWeight: 'bold',
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
};

const Header = () => {
  return (
    <div style={styles.header}>
      <NavLink style={styles.link} to={"/"}>marketdb.github.io</NavLink>
    </div>
  );
}

export default Header;
